import React, { useState, useEffect } from "react";
import "./landingimg.css";
import { Link } from 'react-router-dom';
import Navbarn from "./navbarn";

const Landingimg = () => {
  

  const loc = window.location;
  const baseUrl = `${loc.protocol}//${loc.hostname}${loc.hostname === 'localhost' ? ':5000' : ''}`;
  const dynamicpart = '/logOut';
  const fullUrl = baseUrl + dynamicpart;

  const dynamicrequireAuth = '/requireAuth';
  const requireAuthurl = baseUrl + dynamicrequireAuth;

  



    return (
      <>  
        <div className="landingimgcontainer">
             <img src="https://optimize.sirv.com/silwane/zebra.jpg" className="landingimg" alt="SilwaneNatureReserve" />

             <Navbarn />

             <div className="landingintro">
                <p className="landingintrop">GET BACK TO NATURE</p>
                <h2 className="landingintroh2">SILWANE</h2>
                <p className="landingintropi">Nature Reserve</p>
             </div>

          
        </div>
      </>
    );
  
};

export default Landingimg;